export default "__VITE_ASSET__CwdSC58p__"